import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Zendesk',
  setup(__props) {

const { getters } = store;

const zendeskActive = computed(() => getters.getZendeskInfo.isActive);
const zendeskKey = computed(() => getters.getZendeskInfo.key);

onMounted(() => {
  if (zendeskActive.value) {
    const script = document.createElement('script');
    script.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey.value}`);
    // script.setAttribute('src', `/zendesk.min.js?key=${zendeskKey.value}`);
    script.setAttribute('id', 'ze-snippet');
    document?.querySelector('head')?.append(script);
  }
});

return { __sfc: true,getters, zendeskActive, zendeskKey }
}

})